import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/users/$organisationId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/users/$organisationId/system-managers',
      params: { organisationId: params.organisationId },
    })
  },
})
